<div nz-row>
    <div nz-col nzSpan="8" nzOffset="8" class="forgot-password">
        <h1 nz-typography>Ai uitat parola?</h1>
        <form nz-form [formGroup]="forgotPasswordForm" class="forgot-password-form" (ngSubmit)="onSubmit()">

            <nz-form-item>
                <nz-form-control nzErrorTip="Please input your email!">
                    <nz-input-group [nzPrefix]="prefixEmail">
                        <input type="text" nz-input formControlName="email" placeholder="Email" />
                    </nz-input-group>
                    <ng-template #prefixEmail><i nz-icon nzType="mail" nzTheme="outline"></i></ng-template>
                </nz-form-control>
            </nz-form-item>

            <button nz-button class="forgot-password-form-button forgot-password-form-margin" [nzType]="'primary'" [nzLoading]="loading">Trimite</button>
            
            <nz-alert *ngIf="error" nzType="error" nzMessage="{{error}}" nzShowIcon></nz-alert>
        </form>
    </div>
</div>